
export function mergeFetchedMessages<T extends { id: string; createdAt: string }>(
  prev: T[],
  fetched: T[],
): T[] {
  if (fetched.length === 0) return fetched;
  const seen = new Set(fetched.map((m) => m.id));
  const lastAt = fetched[fetched.length - 1].createdAt;
  const newer = prev.filter((m) => !seen.has(m.id) && m.createdAt > lastAt);
  return newer.length > 0 ? [...fetched, ...newer] : fetched;
}

export function mergeReads<T extends { userId: string; lastReadAt: string }>(
  prev: Record<string, T>,
  fetched: T[],
): Record<string, T> {
  const next = { ...prev };
  for (const r of fetched) {
    const known = next[r.userId];
    if (!known || known.lastReadAt < r.lastReadAt) next[r.userId] = r;
  }
  return next;
}

export function belongsToFeed(message: { internal?: boolean }, kind: 'chat' | 'notes'): boolean {
  return Boolean(message.internal) === (kind === 'notes');
}

export function countUnreadNotes(
  notes: Array<{ authorId: string; createdAt: string }>,
  readAt: string | null,
  userId: string | undefined,
): number {
  return notes.filter((n) => n.authorId !== userId && (!readAt || n.createdAt > readAt)).length;
}
